import React from 'react';

import './Footer.scss';
import useIGTranslation from 'hooks/useIGTranslation';
import { TokenState } from '@incentivegames/ig-frontend-common/lib/contexts/userContext';
import CountDownClock from 'components/CountDownClock/CountDownClock';

export interface FooterProps {
  handleHowToPlayClick: () => void;
  roundStartTime?: number;
  tokenState: TokenState;
}

const Footer = ({ roundStartTime, handleHowToPlayClick, tokenState }: FooterProps) => {
  const { t } = useIGTranslation();
  const renderRoundOpen = process.env.REACT_APP_REGION !== 'bg';

  const renderRoundInformation = () => {
    if ((tokenState === TokenState.InvalidToken || tokenState === TokenState.NoTokenReceived) && !!roundStartTime && roundStartTime > new Date().getTime() && process.env.REACT_APP_REGION !== 'bg') {
      return <div className="home-footer__text">{t('log-in-to-play')}</div>;
    }

    if (!!roundStartTime && roundStartTime < new Date().getTime()) {
      return renderRoundOpen ? <div className="home-footer__text">{t('round-open')}</div> : <div></div>;
    }

    if (!!roundStartTime) {
      return <CountDownClock roundStartTime={roundStartTime}></CountDownClock>;
    }

    return null;
  };
  return (
    <div className="home-footer" data-testid="home-footer">
      {renderRoundInformation()}
      <button className="home-footer__link" onClick={handleHowToPlayClick}>
        {t('more-information')}
      </button>
    </div>
  );
};

export default Footer;
